import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import { AiFillInfoCircle } from 'react-icons/ai';
import axios from '../../Api/axios';
import {
  EmptySpace,
  ErrorText,
  FeedbackText,
  FormHeader,
  InputWrapper,
  LoginButton,
  LoginContainer,
  LoginForm,
  LoginInput,
  LoginInput2,
  LoginSectionLeft,
  LoginSectionRight,
  LoginWrapper,
  LogoImage,
  MobileLogo,
  Checkbox,
  CheckboxWrapper,
  CheckboxText,
  CheckboxTextWrapper,
} from './registerElements';
import Logo from '../../Images/General/logoWhite.png';
import Logo2 from '../../Images/General/Logo.png';

// REGEX
const EMAIL_REGEX = /^[a-z0-9]+@[a-z]+\.[a-z]{2,3}$/;
const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%_.-]).{8,24}$/;

// Default state
const initialState = {
  name: '',
  surname: '',
  email: '',
  password: '',
  password2: '',
  company: '',
  phone: '',
  social: '',
  handle: '',
};

const RegisterSection = () => {
  const [state, setState] = useState(initialState);
  const [feedback, setFeedback] = useState('');
  const [recaptchaValue, setRecaptchaValue] = useState('');

  const [receive, setReceive] = useState(false);
  const [terms, setTerms] = useState(false);

  const [validEmail, setValidEmail] = useState(false);

  const [validPassword, setValidPassword] = useState(false);
  const [validMatch, setValidMatch] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!terms) {
      setFeedback('Terms & Conditions not accepted');
      return;
    }

    // Security
    const v1 = EMAIL_REGEX.test(state.email);
    const v2 = PWD_REGEX.test(state.password);

    if (!v1 || !v2) {
      setFeedback('Invalid Entry');
      return;
    }

    if (!recaptchaValue) {
      setFeedback('Please verify ReCAPTCHA');
      return;
    }
    // Security END

    try {
      axios.post(
        '/register',
        JSON.stringify({
          name: state.name,
          surname: state.surname,
          email: state.email,
          password: state.password,
          company: state.company,
          phone: state.phone,
          social: state.social,
          handle: state.handle,
          responseKey: recaptchaValue,
          receive,
        }),
        {
          headers: { 'Content-Type': 'application/json' },
          withCredentials: true,
        },
      ).then((res) => {
        if (res.data.status === 'error') setFeedback(res.data.message);
        else {
          setFeedback(res.data.message);
          navigate('/verify', { state: { email: state.email } });
        }
      }).catch((error) => {
        if (error.response.status === 409
          || error.response.status === 400) setFeedback(error.response.data.message);
        else if (error) setFeedback('No server response');
        else {
          setFeedback('Something went wrong');
          console.log('Error', error.message);
        }
      });
    } catch (err) {
      if (!err?.response) setFeedback('No server response');
      else setFeedback('Registration failed');
    }
  };

  const handleInput = (e) => {
    const input = e.currentTarget.name;
    const { value } = e.currentTarget;

    setState((prev) => ({ ...prev, [input]: value }));
  };

  const recaptchaChange = (value) => {
    setRecaptchaValue(value);
  };

  // Email verification
  useEffect(() => {
    const result = EMAIL_REGEX.test(state.email);
    setValidEmail(result);
  }, [state.email]);

  // Password verification
  useEffect(() => {
    const result = PWD_REGEX.test(state.password);
    setValidPassword(result);
    const match = state.password === state.password2;
    setValidMatch(match);
  }, [state.password, state.password2]);

  // Error handling
  useEffect(() => {
    setFeedback('');
  }, [state.password, state.password2, state.email, recaptchaValue, terms]);

  return (
    <LoginContainer>
      <LoginWrapper>
        <LoginSectionLeft>
          <MobileLogo src={Logo2} />
          <LoginForm onSubmit={handleSubmit}>
            <FormHeader>Register</FormHeader>
            <InputWrapper>
              <LoginInput2
                required
                value={state.name}
                onChange={handleInput}
                placeholder="Name *"
                autoComplete="off"
                type="text"
                name="name"
              />
              <LoginInput2
                required
                style={{ marginLeft: '25px' }}
                value={state.surname}
                onChange={handleInput}
                placeholder="Surname *"
                autoComplete="off"
                type="text"
                name="surname"
              />
            </InputWrapper>
            <EmptySpace />
            <LoginInput
              required
              value={state.email}
              autoComplete="off"
              aria-invalid={validEmail ? 'false' : 'true'}
              onChange={handleInput}
              placeholder="E-mail *"
              aria-describedby="uidnote"
              type="email"
              name="email"
            />
            {state.email && !validEmail && (
            <ErrorText id="uidnote">
              <AiFillInfoCircle />
              &nbsp;
              Please enter a valid E-mail adress.
            </ErrorText>
            )}
            <EmptySpace />
            <LoginInput
              required
              value={state.password}
              onChange={handleInput}
              placeholder="Password *"
              autoComplete="off"
              aria-invalid={validPassword ? 'false' : 'true'}
              aria-describedby="uidnote2"
              type="password"
              name="password"
            />
            {state.password && !validPassword && (
            <ErrorText id="uidnote2">
              <AiFillInfoCircle />
              &nbsp;
              4 to 24 characters.
              <br />
              Must begin with a letter.
              <br />
              Must contain an uppercase letter.
              <br />
              Must contain Symbols such !@#$%^&*.
            </ErrorText>
            )}
            <EmptySpace />
            <LoginInput
              required
              value={state.password2}
              onChange={handleInput}
              placeholder="Confirm Password *"
              autoComplete="off"
              aria-invalid={validMatch ? 'false' : 'true'}
              aria-describedby="uidnote3"
              type="password"
              name="password2"
            />
            {state.password2 && !validMatch && (
            <ErrorText id="uidnote3">
              <AiFillInfoCircle />
              &nbsp;
              Passwords are not matching.
            </ErrorText>
            )}
            <EmptySpace />
            <InputWrapper>
              <LoginInput2
                value={state.company}
                onChange={handleInput}
                placeholder="Company"
                type="text"
                name="company"
              />
              <LoginInput2
                style={{ marginLeft: '25px' }}
                value={state.phone}
                onChange={handleInput}
                placeholder="Phone"
                type="tel"
                name="phone"
              />
            </InputWrapper>
            <EmptySpace />
            <InputWrapper>
              <LoginInput2
                value={state.handle}
                onChange={handleInput}
                placeholder="Handle"
                type="text"
                name="handle"
              />
              <LoginInput2
                style={{ marginLeft: '25px' }}
                value={state.social}
                onChange={handleInput}
                placeholder="Social"
                type="text"
                name="social"
              />
            </InputWrapper>
            <CheckboxWrapper>
              <CheckboxTextWrapper>
                <Checkbox onChange={(e) => setTerms(e.target.value)} type="checkbox" />
                <CheckboxText>
                  I have read and accept the
                  {' '}
                  <a style={{ color: '#33682c' }} href="https://carboncollectiblenfts.com/terms_and_conditions" target="_blank" rel="noreferrer">terms and conditions</a>
                </CheckboxText>
              </CheckboxTextWrapper>
              <CheckboxTextWrapper>
                <Checkbox onChange={(e) => setReceive(e.target.value)} type="checkbox" />
                <CheckboxText>I want to receive newsletters and updates</CheckboxText>
              </CheckboxTextWrapper>
            </CheckboxWrapper>
            <EmptySpace />
            <ReCAPTCHA
              style={{ marginTop: '10px', marginLeft: 'auto', marginRight: 'auto' }}
              sitekey={process.env.REACT_APP_CAPTCHA_KEY}
              size={window.innerWidth > 480 ? 'normal' : 'compact'}
              theme="light"
              onChange={recaptchaChange}
            />
            <FeedbackText>{feedback}</FeedbackText>
            <LoginButton disabled={!validMatch ? true : false || !validEmail || !validPassword || !recaptchaValue} type="submit">Register</LoginButton>
          </LoginForm>
        </LoginSectionLeft>
        <LoginSectionRight>
          <LogoImage src={Logo} />
        </LoginSectionRight>
      </LoginWrapper>
    </LoginContainer>
  );
};

export default RegisterSection;
